import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getCookie } from '@client/services/cookies'

import { createContact } from '@store/ducks/simulate'

import Footer from '@components/Footer'

import useUtm from '@hooks/useUtm'
import useContact from '@hooks/useContact'
import useDataLayer from '@hooks/useDataLayer'
import useReCaptcha from '@hooks/useReCaptcha'
import useRouteBuilder from '@hooks/useRouteBuilder'

import { Facebook, Instagram, Youtube } from '@assets/icons'

import {
  Header,
  HowItWorks,
  Wellness,
  Benefits,
  Gyms,
  Comments,
  FixedBar,
  CompanyPlans,
} from './sections'

export default function Home() {
  const simulate = useSelector(state => state.simulate)

  const [loading, setLoading] = useState(false)

  const { applyUtm } = useUtm()
  const { contact } = useContact()
  const { setRecaptcha } = useReCaptcha()
  const { events, values } = useDataLayer()
  const { buildRoute } = useRouteBuilder()

  const dispatch = useDispatch()
  const history = useHistory()

  const links = [
    {
      url: 'https://gympass.com',
      label: 'smb_acquisition_footer.call_to_action.home',
    },
    {
      url: 'https://hs.gympass.com/pt-br/faq-empresas-obrigado',
      label: 'smb_acquisition_footer.call_to_action.faq',
    },
  ]

  const social = [
    {
      url: 'https://www.facebook.com/GympassBrasil/',
      icon: Facebook,
      alt: 'facebook-link',
    },
    {
      url: 'https://www.instagram.com/gympass',
      icon: Instagram,
      alt: 'instagram-link',
    },
    {
      url: 'https://www.youtube.com/channel/UCcPoNt0XQymennhuyZBmYMA',
      icon: Youtube,
      alt: 'youtube-link',
    },
  ]

  useEffect(() => {
    if (contact.id) {
      applyUtm(contact.id)
    }
  }, [contact.id])

  if (simulate && !simulate.recaptchaToken) {
    setRecaptcha()
  }

  if (!simulate) {
    setRecaptcha()
  }

  async function handleContactSubmit(contactData) {
    const hubspotutk = getCookie('hubspotutk')

    const data = {
      ...simulate,
      ...contactData,
      country: 'Brazil',
      token: hubspotutk,
      funnelStage: 'company_info',
    }

    try {
      setLoading(true)

      await dispatch(createContact(data))

      events.simulatorInteraction(values.MAIN_BUTTON)

      setLoading(false)

      history.push(buildRoute('simulate/company-info'))
    } catch (error) {
      if (error.response.status === 409) {
        history.push(buildRoute('thank-you/already-eligible'))
      }
    }
  }

  return (
    <>
      <FixedBar />
      <Header onSubmit={handleContactSubmit} onLoading={loading} />
      <CompanyPlans />
      <HowItWorks />
      <Wellness />
      <Benefits />
      <Gyms />
      <Comments />
      <Footer links={links} social={social} />
    </>
  )
}
